import { PowerbiReportService } from "../../powerbi-report.service";

export const servicesProviders =
  [
    PowerbiReportService
  ];
